import { css } from 'linaria';
import { styled } from 'linaria/react';

export const captionStyles = css`
	display: block;
	margin-top: 24px;
`;

export const InfoBar = styled.div`
	display: flex;
	flex-direction: row;
	align-content: start;
	padding: 12px;
	margin-top: 40px;
	column-gap: 8px;
	background-color: var(--secondary-yellow-light);
	border-radius: 8px;
`;

export const StyledUl = styled.ul`
	padding: 0;
	margin: 4px 0 0;
	list-style: none;
`;

export const titleStyles = css`
	margin-top: 8px;
`;
